import React, { useState } from 'react'
import DepartmentManagement from '../components/DepartmentManagement/DepartmentManagement'

const PageDepartmentManagement = () => {
  return <>
  <DepartmentManagement></DepartmentManagement>
  </>
}

export default PageDepartmentManagement
